// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"165":"c2934b35","453":"63ded756","796":"764b8736"}[chunkId] + ".chunk.js";
};